import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { CheckoutAssistedFinanceStyled } from '../CheckoutAssistedFinanceStyled';
import { media } from '../../../styles/media';

export const CheckoutAssistedFinanceStyledDS = styled(CheckoutAssistedFinanceStyled)`
    
`;
